export default {
  image: 'A4_2.png',
  pdf: '220922_WA-VHFWDVS_001_A4_2_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-VHFWDVS-001',
    technicalValues: {
      soundReductionIndex: {
        output: '52,5',
        value: 52.5
      },
      heatTransferCoefficient: {
        output: '0,14',
        value: 0.14
      },
      fireBehavior: {
        output: 'normalentflammbar (B2)',
        value: 'B2'
      },
      fireResistanceOuter: {
        output: 'F 90-B',
        value: 'F-90-B'
      },
      fireResistanceInner: {
        output: 'F 30-B',
        value: 'F-30-B'
      }
    },
    name: 'Wandaufbau mit VHF und WDVS l Aufbau 1',
    construction: {
      composition: [
        {
          output: 'organischer Unterputz',
          type: 'render',
          title: { de: 'Putz' },
          value: 'org-1'
        },
        {
          output: '80 mm Sto-Weichfaserplatte 039 VHF',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'wvhf-80'
        },
        {
          output: '12 mm Putzträgerplatte',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: 'opr-12'
        },
        {
          output: '60/180',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-180'
        },
        {
          output: '180 mm Steinwolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cirw-180'
        },
        {
          output: '12 mm OSB-Platte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'ia-12'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: 'io-12'
        }, 
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '331,5',
        value: 331.5
      }
    }
  }
}
